var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"o-navigation-item",class:_vm.getClass(),attrs:{"to":_vm.to,"tag":"li"}},[_c('o-icon',{attrs:{"type":_vm.icon}}),_c('p',{staticClass:"no-select"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }